import { z } from 'zod';
import { nameAndCode } from './common';

/**
 * A bench.
 *
 * `code` is the natural key: the seed upserts on it, and the rate-list importer
 * matches a detected group row ("SEROLOGY") against it before creating a new
 * one. Nine rows ship in the migration.
 */
export const createDepartmentSchema = z.object({
  ...nameAndCode,
  /**
   * The order the printed rate list and the stock-entry launcher list benches in.
   *
   * Explicit rather than alphabetical, because a rate list reads in the order
   * the lab thinks about its work — Serology, Haematology, Chemistry — not in
   * the order the alphabet happens to put those words.
   */
  sort_order: z.coerce.number().int().min(0).max(9999).default(0),
  is_active: z.boolean().default(true),
});
export type CreateDepartmentInput = z.infer<typeof createDepartmentSchema>;

export const updateDepartmentSchema = createDepartmentSchema;
export type UpdateDepartmentInput = z.infer<typeof updateDepartmentSchema>;
